import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import actionCreators from '../actions/index';
import Header from '../components/Layout/Header/Header'
import Footer from '../components/Layout/Footer/Footer'

const mapStateToProps = (state) => {
  const { global } = state;

  return {
    global
  }
};

const mapDispatchToProps = (dispatch) =>
  (bindActionCreators(actionCreators, dispatch));

class MainContainer extends React.Component {

  render() {
    return (
      <div>
        <Header />
        {React.cloneElement(this.props.children, this.props)}
        <Footer />
      </div>
    );
  }
};

export default connect(mapStateToProps, mapDispatchToProps)(MainContainer);



/** WEBPACK FOOTER **
 ** ./src/containers/Main.js
 **/